.title {
  font-size: 18px;
  font-weight: 400;
  color: #3b3b3b;
  text-align: center;
}
